import { lazy } from 'react'

import { useParams } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { useTravelRequestDetailPresenter } from '@webapp/modules/expense/features/get-travel-details/presenters/UseTravelRequestDetailPresenter'
import messages from './messages'
import {
  TravelApprovalsPageTabStatuses,
  type TravelEditPageParams,
  TravelStatusPageTabStatuses,
} from './types'

const TravelEditViewChunk = lazy(() =>
  import('@webapp/modules/expense/feature-sets/TravelEditView').then(
    ({ TravelEditView }) => ({
      default: TravelEditView,
    })
  )
)

export const TravelEditPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()
  const { uuid } = useParams<TravelEditPageParams>()

  const {
    data: { travel },
  } = useTravelRequestDetailPresenter({ uuid })

  const breadcrumbTarget = travel?.canApprove
    ? {
        link: url('TravelApprovalsPage', {
          status: TravelApprovalsPageTabStatuses.PENDING,
        }),
        name: intl.formatMessage(messages.travelApprovalsPageTitle),
      }
    : {
        link: url('TravelStatusPage', {
          status: TravelStatusPageTabStatuses.PENDING,
        }),
        name: intl.formatMessage(messages.travelStatusPageTitle),
      }

  return (
    <Page
      pageTitle={intl.formatMessage(messages.travelDetailsPageTitle)}
      breadcrumbs={[
        breadcrumbTarget,
        {
          name: intl.formatMessage(messages.travelDetailsPageTitle),
        },
      ]}
    >
      {/* Remount per travel: the view's modal state belongs to one uuid */}
      <TravelEditViewChunk key={uuid} />
    </Page>
  )
}
